/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import wordCount from 'utils/word-count';
import './Statement.scss';

/**
 * This is the Statement component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Statement({ className, children, limit }) {
  let decoration = {};

  if (wordCount(children) < limit) {
    decoration = { 'stagger-text': 'true' };
  } else {
    decoration = { appear: 'true' };
  }

  return (
    <blockquote
      className={`excerpt statement ${className}`.trim()}
      {...decoration}
    >
      <p dangerouslySetInnerHTML={{ __html: children }} />
    </blockquote>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Statement.propTypes = {
  className: PropTypes.string,
  children: PropTypes.string,
  limit: PropTypes.number.isRequired,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Statement.defaultProps = {
  className: '',
  children: '',
  limit: 20,
};

export default Statement;
